<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="section-title">{{ $t("makeARefund") }}</div>
    </div>
    <div class="white-wrapper mt-4">
      <!-- SECTION 1 -->
      <div class="row" v-if="section.one">
        <div class="col-lg-6 col-xl-4">
          <div class="dropdown-curve-container">
            <label :class="dropDown.cinemas && dropDown.cinemas.length > 0
              ? 'shift-up'
              : ''
              ">{{ $t("select") }} {{ $tc("cinema", 1) }}</label>
            <multiselect :disabled="isRoleID" :options="dropDown.cinemas" v-model="dropDown.selectedCinema"
              :searchable="true" label="cine_name" track-by="cine_id" placeholder="Select Cinema"
              @input="onSelectCinema($event)" :allowEmpty="false" :showLabels="false"></multiselect>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 text-center mb-5">
          <div class="input-material mb-4">
            <input v-model="booking_id" type="search" required="required" />
            <label>{{ $tc("ticket", 1) }} {{ $t("no") }}</label>
          </div>
        </div>

        <div class="col-lg-4">
          <button v-on:click="show2()" class="btn-blue-lg">
            {{ $t("submit") }}
          </button>
        </div>
      </div>

      <!-- SECTION 2  -->
      <div class="refund-center-content" v-if="section.two">
        <div class="col-lg-8 col-xl-8 mx-auto mb-5">
          <div class="row">
            <div class="col-6 mb-4">
              <div class="input-material">
                <input type="text" :value="booking_id" required="required" />
                <label>{{ $tc("ticket", 1) }} {{ $t("no") }}</label>
              </div>
            </div>
            <div class="col-6 mb-4">
              <div class="input-material">
                <div class="dropdown-curve-container">
                  <label :class="RefundReason.length > 0 ? 'shift-up' : ''">{{ $t("select") }} {{ $tc("refund", 2) }}
                    {{ $tc("reason", 2) }}</label>
                  <div class="d-flex justify-content-center align-items-center">
                    <b-dropdown :text="RefundReason" variant="dropdown-curve" class="w-100">
                      <b-dropdown-item href="#" v-for="(item, itemIndex) in Refunds" :key="itemIndex"
                        v-on:click="onSelectHandler(item)">{{ item.rr_reason }}</b-dropdown-item>
                    </b-dropdown>
                    <!-- <Tooltip :title="$t('vendorsCountry_tooltip')" /> -->
                  </div>
                </div>
              </div>
            </div>

            <div class="col-6 mb-4">
              <div class="dropdown-curve-container">
                <label :class="selectedPaymentObj ? 'shift-up' : ''">{{ $t("select") }} {{ $tc("refund", 2) }}
                  {{ $tc("mode", 2) }}</label>
                <multiselect v-model="selectedPaymentObj" @select="onSelectHandlerPayment($event)" placeholder=""
                  track-by="pm_id" label="pm_payment_mode" :options="paymentModes" :multiple="false"></multiselect>
              </div>
            </div>

            <div v-if="false" class="col-6 mb-4">
              <div class="input-material mb-4">
                <div class="dropdown-curve-container">
                  <label :class="selectedPayment.length > 0 ? 'shift-up' : ''">{{ $t("select") }} {{ $tc("refund", 2) }}
                    {{ $tc("mode", 2) }}</label>
                  <div class="d-flex justify-content-center align-items-center">
                    <b-dropdown :text="selectedPayment" variant="dropdown-curve" class="w-100">
                      <b-dropdown-item href="#" v-for="(item, itemIndex) in getPaymentTypesList" :key="itemIndex"
                        v-on:click="onSelectHandlerPayment(item)">{{ item.pm_payment_mode }}</b-dropdown-item>
                    </b-dropdown>
                    <Tooltip :title="$t('vendorsCountry_tooltip')" />
                  </div>
                </div>
              </div>
            </div>

            <div class="col-6 mb-4">
              <multiselect v-if="isPrivateShow" :disabled="ALLOW_PARTIAL_REFUND == 'N'" v-model="Selectedseats"
                @select="onSelectSeats($event)" @remove="onRemoveSeats($event)" placeholder="Select Seats"
                track-by="sl_id" label="sl_seat_name" :options="seats" :multiple="true">
                <template slot="option" slot-scope="props"><span>{{
                  props.option.mycinema_booking_type_id &&
                    props.option.mycinema_booking_type_id == 3
                    ? "Entire Show"
                    : props.option.sl_seat_name
                }}</span>
                </template>

                <template slot="tag" slot-scope="props">
                  <span class="multiselect__tag">
                    <span>{{
                      props.option.mycinema_booking_type_id &&
                        props.option.mycinema_booking_type_id == 3
                        ? "Entire Show"
                        : props.option.sl_seat_name
                    }}</span>
                  </span>
                </template>
              </multiselect>
              <multiselect v-else v-model="Selectedseats" :disabled="ALLOW_PARTIAL_REFUND == 'N'"
                @select="onSelectSeats($event)" @remove="onRemoveSeats($event)" placeholder="Select Seats"
                track-by="sl_id" label="sl_seat_name" :options="seatsArr" :multiple="true" group-values="SeatsArray"
                group-label="label" :group-select="true"></multiselect>
            </div>

            <div class="col-12 mb-4" v-if="allow_fnb_refund == 'Y' && FnbItemArray.length > 0">
              <div class="dropdown-curve-container">
                <label :class="FnbItemArray && FnbItemArray.length > 0 ? 'shift-up' : ''
                  ">{{ $tc("fnb", 2) }}</label>
                <multiselect :disabled="ALLOW_PARTIAL_REFUND == 'N'" v-model="FnbItemArray" placeholder="Fnb Items"
                  track-by="item_id" label="item_name" :options="FnbItemArray" :multiple="true">
                </multiselect>
              </div>
            </div>

            <div class="col-6 mb-4" v-if="refund.payment_mode_id == 11 && !onlineMode">
              <div class="input-material">
                <input type="search" v-model="search_ccn" name="cash_card_number" id="cash_card_number"
                  v-debounce:500="onSearchCashCard" v-on:search="onSearchCashCard" placeholder="xxx-xxxxxxxx-x"
                  :class="{ invalid_input: cc_input_error }" />
                <label>{{ "Enter Cash Card Number" }}</label>
              </div>
              <p class="error_message">
                <span v-if="cc_input_error">{{ cc_input_error }}</span>
              </p>
            </div>

            <div class="col-12 mb-4" v-if="showCashCardCustomer && !onlineMode">
              <b-collapse v-model="showCashCardCustomer">
                <table class="list-view-table border mb-0" v-if="checkCustomer(cashCardsList[0])">
                  <thead>
                    <tr>
                      <th>{{ $tc("card") }} {{ $tc("number") }}</th>
                      <th>{{ $tc("customer") }} {{ $tc("name") }}</th>
                      <th class="text-right">{{ $t("balance") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(card, key) in cashCardsList" :key="key">
                      <td>{{ card.cash_card_visible }}</td>
                      <td>
                        {{ getCardName(card) }}
                      </td>
                      <td class="text-right">
                        {{ currFormat(card.balance_amount) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table class="list-view-table border mb-0" v-else>
                  <thead>
                    <tr>
                      <th>{{ $tc("card") }} {{ $tc("number") }}</th>
                      <th class="text-center" colspan="2">
                        {{ $t("action") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(card, key) in cashCardsList" :key="key">
                      <td>{{ card.cash_card_visible }}</td>
                      <td class="p-3" colspan="2">
                        <div class="
                            d-flex
                            align-items-center
                            justify-content-center
                          ">
                          <b-form-radio value="1" class="j-radio" v-model="cardSaleType">
                            <div>
                              <span>{{ $t("street_sale") }}</span>
                            </div>
                          </b-form-radio>
                          <strong class="mx-3">OR</strong>

                          <b-form-radio value="2" class="j-radio" v-model="cardSaleType">
                          </b-form-radio>
                          <div class="w-50">
                            <div class="dropdown-curve-container">
                              <multiselect v-model="selectedCustomer" :options="customerList"
                                placeholder="Select customer" track-by="cust_id" label="customer_name"
                                class="customer_drop_down" :disabled="cardSaleType == 1" :class="{
                                  invalid_input: cc_customer_field_error,
                                }" @select="onSelectCustomer($event)"></multiselect>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-collapse>
            </div>

            <div class="col-12 mb-4" v-if="refund.payment_mode_id == 29 && !onlineMode">
              <div class="row" v-if="walletDetails.isApplied == 'N'">
                <div class="col-6 h-100 text-center">
                  <div class="input-material">
                    <input type="search" v-model="search_wallet_no" name="search_wallet_no" id="search_wallet_no"
                      v-on:search="onSearchWallet" placeholder="xxx-xxxxxxxx-x" />
                    <label>{{ "Enter Registered Number" }}</label>
                  </div>
                </div>
                <div class="col-6 h-100">
                  <div class="btn btn-outline-primary" @click="onSearchWallet">
                    Search
                  </div>
                </div>
              </div>

              <div class="row" v-if="walletDetails.isApplied == 'Y'">
                <div class="col-12 d-flex align-items-center">
                  <div class="wallet-heading">
                    {{ "Wallet Details" }}
                  </div>
                  <div class="rmv-btn ml-4">
                    <span class="icon-delete-red" @click="removeWalletDetails()"></span>
                  </div>
                </div>
                <table class="list-view-table border mb-0">
                  <thead>
                    <tr>
                      <th>Customer Name</th>
                      <th class="text-right">Mobile No.</th>
                      <th class="text-right">Email</th>
                      <th class="text-right">Balance</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ walletDetails.cust_name }}</td>
                      <td class="text-right">
                        {{ walletDetails.cust_mobile || "-" }}
                      </td>
                      <td class="text-right">
                        {{ walletDetails.cust_email || "-" }}
                      </td>
                      <td class="text-right">
                        {{
                          parseFloat(walletDetails.wallet_balance).toFixed(this.MIN_FRACTION_DIGITS) ||
                          0
                        }}
                        {{ refund.curr_code }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="col-6 mb-4" v-if="onlineMode">
              <div class="input-material">
                <input type="text" :disabled="onlineMode" id="online_enterRefundAmount" name="online_enterRefundAmount"
                  :value="BookingDetails.pm_payment_mode" />
                <label>{{ "Payment Mode" }}</label>
              </div>
            </div>

            <div class="col-6 mb-4" v-if="onlineMode">
              <div class="input-material">
                <input type="text" :disabled="onlineMode" id="online_enterRefundAmount" name="online_enterRefundAmount"
                  :value="getTotalValue" />
                <label>{{ "Refund amount" }}</label>
              </div>
            </div>
          </div>
          <div class="row" v-if="!onlineMode">
            <div class="col-6 mb-4">
              <!-- <p>
                Net Amount: {{ currFormat(refund.sb_total_net_amount) }}&nbsp;{{
                  refund.curr_code
                }}
              </p> -->
              <p>
                Ticket Gross Amount:
                {{ currFormat(refund.sb_total_amount) }}&nbsp;{{
                  refund.curr_code
                }}
              </p>
              <p v-if="refund.add_ons_gross_charge && refund.add_ons_gross_charge > 0
              ">
                Addons Charges:
                {{ currFormat(refund.add_ons_gross_charge) }}&nbsp;{{
                  refund.curr_code
                }}
              </p>
              <p v-if="allow_fnb_refund == 'Y' &&
                getFnbTotalDetails.fnb_total_amount_before_offer
              ">
                FNB Gross Amount:
                {{
                  currFormat(getFnbTotalDetails.fnb_total_amount_before_offer)
                }}&nbsp;{{ refund.curr_code }}
              </p>
              <p v-if="(offer_price && parseInt(offer_price) !== 0) ||
                parseFloat(getFnbTotalDetails.fnb_offer_price)
              ">
                Offer Discount:
                {{
                  currFormat(
                    parseFloat(offer_price) +
                    parseFloat(getFnbTotalDetails.fnb_offer_price || 0)
                  )
                }}&nbsp;{{ refund.curr_code }}
              </p>
              <p class="font-weight-bold fs-14">
                Total Amount Paid:
                {{
                  currFormat(
                    refund.sb_total_amount_paid -
                    offer_price +
                    parseFloat(refund.add_ons_gross_charge || 0) +
                    parseFloat(getFnbTotalDetails.fnb_gross_amount)
                  )
                }}&nbsp;{{ refund.curr_code }}
              </p>
            </div>
            <div class="col-6 mb-4">
              <div class="input-material" v-if="allow_fnb_refund == 'Y'">
                <input disabled type="text" id="enterOverAllRefundAmount" name="enterOverAllRefundAmount"
                  v-model="totalRefundAmount" />
                <label>{{ "Refund amount" }}</label>
              </div>
              <div class="input-material" v-else>
                <input disabled type="text" id="enterRefundAmount" name="enterRefundAmount"
                  v-model="refund.enterRefundAmount" @focus="onClickInputHandler('showAmountKeyboard')" />
                <label>{{ "Refund amount" }}</label>
              </div>
              <div class="d-flex align-items-center pt-2 justify-content-end" v-if="FnbItemArray.length > 0">
                <b-form-checkbox type="checkbox" class="j-checkbox pb-0" v-model="allow_fnb_refund" unchecked-value="N"
                  value="Y" />
                <label class="mb-0 mr-3">{{ "Refund F&B Also" }}</label>
              </div>
            </div>
          </div>

          <div class="col-lg-5 col-12" style=" margin-top: -20px;" v-if="isQfx">
            <div class="d-flex">
              <b-form-checkbox class="ml-3 j-checkbox pb-0" v-model="amount_is_active" unchecked-value="N"
                value="Y"></b-form-checkbox>
              <span class="ml-1">{{
                amount_is_active === "Y" ? "Amount Refund" : "Only Ticket Refund"
              }}</span>
            </div>
          </div>

          <div class="row">
            <div class="col-12 text-center">
              <button class="btn-grey-lg" v-on:click="show1()">
                {{ $t("cancel") }}
              </button>
              <button v-if="onlineMode" class="btn-blue-lg" :disabled="disableRefundBtn || btnDis"
                :class="disableRefundBtn ? 'disableRefundBtn' : ''" v-on:click="processRefund()">
                {{ "Refund " }}&nbsp;{{ getTotalValue }}
              </button>
              <button v-else class="btn-blue-lg" :disabled="disableRefundBtn || btnDis"
                :class="disableRefundBtn ? 'disableRefundBtn' : ''" v-on:click="checkRefundPayMode()">
                {{ $t("submit") }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="refund-center-content" v-if="section.three">
        <div class="col-lg-6 col-xl-4 mx-auto text-center mb-5">
          <div class="success-tick-wrapper">
            <span class="success-tick"></span>
            <div class="refund-text font-weight-bold mb-3">Refund Successfull.</div>
          </div>
          <button v-on:click="onClickBack()" class="btn-blue-lg">
            {{ $t("close") }}
          </button>
          <button v-if="checkPrintAvailable" v-on:click="onPrintHandler()" class="btn-blue-lg">
            {{ $t("Print") }}
          </button>
        </div>
      </div>
    </div>
    <b-modal id="confirmStockDeduction" title="Do You Want To Stock In Items Again?" hide-footer no-close-on-backdrop>
      <div class="pb-1">
        <!-- <p class="fs-16 mb-4">{{ `` }}</p> -->
        <table class="table tableItem">
          <thead>
            <tr>
              <th scope="col" style="white-space: nowrap;">Item Name</th>
              <th scope="col">Qty</th>
              <th scope="col" style="white-space: nowrap;">Add to Stock</th>
            </tr>
          </thead>
          <tbody>

            <template v-for="(item, Itemindex) in FnbItemArray">
              <template v-if="item &&
                item.hasOwnProperty('combo_data') &&
                item.combo_data &&
                item.combo_data.length > 0
              ">
                <tr v-for="(combo_item, ci_index) in item.combo_data" :key="ci_index">
                  <td style="word-break:break-word;white-space:break-spaces;">{{ combo_item.item_name }}&nbsp;({{
                    item.fst_item_name
                  }})</td>
                  <td>{{ combo_item.quantity }}</td>
                  <td>
                    <div class="d-flex align-items-center mx-4">
                      <b-form-checkbox v-model="combo_item.reload_stock" value="Y" unchecked-value="N" @change="
                        onChangeStockReload(
                          $event,
                          'combo',
                          Itemindex,
                          ci_index
                        )
                        " class="j-checkbox mb-1 pb-0" name="check-button"></b-form-checkbox>
                    </div>
                  </td>
                </tr>
              </template>

              <template v-else>
                <tr :key="Itemindex">
                  <td style="word-break:break-word;white-space:break-spaces;">{{
                    item.fst_item_name
                  }}</td>
                  <td>{{ item.fst_quantity }}</td>
                  <td>
                    <div class="d-flex align-items-center mx-4">
                      <b-form-checkbox v-model="item.reload_stock" value="Y" @change="
                        onChangeStockReload($event, 'item', Itemindex, null)
                        " unchecked-value="N" class="j-checkbox mb-1 pb-0" name="check-button"></b-form-checkbox>
                    </div>
                  </td>
                </tr>
              </template>
            </template>
          </tbody>
        </table>

        <span class="mx-1"></span>
        <div class="text-center">
          <button v-if="onlineMode" :disabled="disableRefundBtn" :class="disableRefundBtn ? 'disableRefundBtn' : ''"
            class="btn btn-danger btn-danger-lg px-4 fs-14" @click.prevent.stop="processRefund(true)">
            Proceed
          </button>
          <button v-else :disabled="disableRefundBtn" :class="disableRefundBtn ? 'disableRefundBtn' : ''"
            class="btn btn-danger btn-danger-lg px-4 fs-14" @click.prevent.stop="checkRefundPayMode(true)">
            Proceed
          </button>
        </div>
      </div>
    </b-modal>
    <div ref="onPrint" class="d-none">
      <div v-html="EjsData"></div>
    </div>
    <ManagerAuthLogin :moduleName="'dashRefund'" :onCheckAuth="onCheckAuthentication"
      :refId="'authManager_dashRefund'" />
  </div>
</template>

<script>
import PosService from "@/services/PosService.js";
import PosFnbService from "@/services/PosFnbService.js";
import MasterService from "@/services/MasterService.js";
import UserService from "@/services/UserService.js";
import { mapState, mapGetters, mapActions } from "vuex";
import ManagerAuthLogin from "@/components/Partials/AuthManagerLoginPopup";
import Printd from "printd";
import { BASEURL } from "@/config/index";
import { CLIENT_NAME, CLIENT_NAMES_OBJ } from "@/helper/Role";
import _ from "lodash";
import { decryptString, encryptString } from "@/helper/collection";

export default {
  components: {
    ManagerAuthLogin,
  },
  data() {
    return {
      isMif: true,
      amount_is_active: "N",
      btnDis: false,
      walletCustomerType: 0,
      search_wallet_no: "",
      walletDetails: {
        wallet_balance: 0,
        cust_id: null,
        cust_email: "",
        cust_name: "",
        cust_mobile: "",
        isApplied: "N",
      },
      disableRefundBtn: false,
      overAllRefund: "Y",
      allow_fnb_refund: "Y",
      FnbItemArray: [],
      FnbRefundAmount: 0,
      neoleapCardDetails: {
        card_refund_details: null,
        nl_card_name: null,
        refund_card_payment_gateway: null,
      },
      EjsData: null,
      TemplateList: [],
      online_pm_details: {
        srt_payment_type: null,
      },
      onlineMode: false,
      loaderInstance: null,
      noAuth: false,
      isPrivateShow: false,
      cc_customer_field_error: "",
      selectedCustomer: "",
      selected_cust_email: "",
      cashCardDetails: "",
      cardSaleType: 1, // 1 -> street sale AND 2 -> customer sale
      RefundReason: "",
      section: {
        one: true,
        two: false,
        three: false,
      },
      booking_id: "",
      BookingDetails: {
        pm_id: null,
        pm_payment_mode: "",
        bs_id: null,
        booking_source: "",
      },
      refund: {
        sb_id: null,
        booking_id: null,
        enterRefundAmount: null,
        //
        booking_status_id: null,
        rr_reason: null,
        rr_id: null,
        payment_mode_id: null,
        payment_mode_name: "",
        //
        curr_code: null,
        sb_total_net_amount: null,
        sb_total_amount: null,
        sb_total_amount_paid: null,
        seat_amount_total: 0,
      },
      Refunds: [],
      seats: [],
      Selectedseats: [],
      selectedPayment: "",
      selectedPaymentObj: "",
      offer_name: "",
      offer_price: 0,
      voucher_name: "",
      seatsArray: [],
      cashCardsList: [],
      search_ccn: "",
      cc_input_error: "",
      customerList: [],

      selectedBooking: "",
      order_code: "",
      OrderItems: [],
      AlreadyRefunded: [],
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
    };
  },
  watch: {
    Selectedseats: {
      handler: function (seat, oldVal) {
        var vm = this;
        vm.refund.seat_amount_total = 0;
        seat.map((x) => {
          vm.refund.seat_amount_total +=
            parseFloat(x.t_gross_amount) +
            parseFloat(vm.addonsChargesObj["perTicketAddonCharge"] || 0);
        });
        if (seat.length == vm.seats.length) {
          vm.refund.seat_amount_total =
            parseFloat(vm.refund.seat_amount_total) +
            parseFloat(vm.addonsChargesObj["overAllAddonsCharge"] || 0);
        }
        vm.refund.enterRefundAmount = parseFloat(
          vm.refund.seat_amount_total
        ).toFixed(this.MIN_FRACTION_DIGITS);
      },
      deep: true,
    },
    cardSaleType(newVal) {
      if (newVal == 1) {
        this.selectedCustomer = "";
        this.selected_cust_email = "";
      }
    },
  },
  computed: {
    isQfx() {
      return this.authorizeClient(CLIENT_NAMES_OBJ.QFX);
    },
    totalRefundAmount() {
      return this.currFormat(
        parseFloat(this.refund.enterRefundAmount) +
        parseFloat(this.getFnbTotalDetails.fnb_gross_amount)
      );
    },
    getFnbTotalDetails() {
      let obj = {
        fnb_net_amount: 0,
        fnb_gross_amount: 0,
        fnb_offer_price: 0,
        fnb_total_amount_before_offer: 0,
      };
      if (this.FnbItemArray.length > 0 && this.allow_fnb_refund == "Y") {
        this.FnbItemArray.forEach((x) => {
          obj["fnb_net_amount"] += parseFloat(x.fst_amount);
          obj["fnb_gross_amount"] += parseFloat(x.fst_total_amount);
          obj["fnb_total_amount_before_offer"] += parseFloat(
            x.fst_total_amount_before_offer
          );
          obj["fnb_offer_price"] += parseFloat(x.fst_offer_price);
        });
      }
      return obj;
    },
    ...mapGetters([
      "getPaymentTypesList",
      "MANAGER_AUTH_FOR_CHANGES",
      "ALLOW_PARTIAL_REFUND",
    ]),
    _checkPrintAvailable() {
      let status = false;
      if (
        this.TemplateList &&
        this.TemplateList.length > 0 &&
        this.TemplateList[0].refund_temp_name == "Refund-1"
      ) {
        status = true;
      } else {
        status = false;
      }
      return status;
    },
    checkPrintAvailable() {
      return CLIENT_NAME.EMPIRE == this.CLIENT_SETUP_NAME;
    },
    getTotalValue() {
      console.log("this.", this.BookingDetails);
      return parseFloat(
        parseFloat(this.refund.sb_total_amount_paid || 0) -
        parseFloat(this.offer_price || 0) +
        parseFloat(this.refund.add_ons_gross_charge || 0) +
        parseFloat(this.getFnbTotalDetails.fnb_gross_amount || 0) +
        parseFloat(this.BookingDetails.internet_handling_fee || 0)
      ).toFixed(this.MIN_FRACTION_DIGITS);
    },
    isCashCardRefund() {
      if (this.refund.payment_mode_id == 11) {
        return true;
      } else {
        return false;
      }
    },
    addonsChargesObj() {
      let perTicketAddonCharge = 0;
      let overAllAddonsCharge = 0;
      let addonsArray =
        this.BookingDetails.hasOwnProperty("final_addon_gross_charges") &&
          this.BookingDetails.final_addon_gross_charges.length > 0
          ? this.BookingDetails.final_addon_gross_charges
          : [];

      if (addonsArray.length > 0) {
        addonsArray.forEach((y) => {
          y.map((x) => {
            if (x.is_on_per_ticket == "Y") {
              perTicketAddonCharge += x.single_add_ons_price;
            } else {
              overAllAddonsCharge += x.single_add_ons_price;
            }
          });
        });
      }

      console.log("perTicketAddonCharge", perTicketAddonCharge);
      console.log("overAllAddonsCharge", overAllAddonsCharge);

      return {
        perTicketAddonCharge: perTicketAddonCharge,
        overAllAddonsCharge: overAllAddonsCharge,
      };
    },
    paymentModes() {
      let allowedPmIds = [1, 2, 3, 11, 29];
      if (
        this.online_pm_details.hasOwnProperty("srt_payment_type") &&
        this.online_pm_details.srt_payment_type &&
        ["3", "4", "5", "12", "13", "6"].includes(
          String(this.online_pm_details.srt_payment_type)
        )
      ) {
        console.log("COMING INSIDE line909");

        let pmObj = {
          pm_id: this.BookingDetails.pm_id,
          pm_payment_mode: this.BookingDetails.pm_payment_mode || "Online",
        };
        if (
          !this.getPaymentTypesList.some(
            (x) => x.pm_id == this.BookingDetails.pm_id
          )
        ) {
          this.getPaymentTypesList.push(pmObj);
        }
        allowedPmIds.push(pmObj["pm_id"]);
      }

      let pm_id = this.BookingDetails.pm_id
      console.log("pm_id", pm_id)
      console.log("this.isQfx", this.isQfx)

      if (CLIENT_NAME.QFX == this.CLIENT_SETUP_NAME) {
        allowedPmIds.push(24, 28, 26, 36);
      }

      if (CLIENT_NAME.QFX == this.CLIENT_SETUP_NAME && pm_id == 1) {
        allowedPmIds = allowedPmIds.filter(id => id !== 24);
      }
      if (CLIENT_NAME.QFX == this.CLIENT_SETUP_NAME && pm_id == 24) {
        allowedPmIds = allowedPmIds.filter(id => id == 24);
      }
      if (CLIENT_NAME.CINEPOLIS_OMAN == this.CLIENT_SETUP_NAME) {
        allowedPmIds.push(41)
      }

      //console.log('allowedPmIds', allowedPmIds)

      if (["12", "13"].includes(String(this.BookingDetails.pm_id))) {
        allowedPmIds.push(this.BookingDetails.pm_id);
      }

      let paymentModesList = this.getPaymentTypesList.filter((x) =>
        allowedPmIds.includes(x.pm_id)
      );

      if (paymentModesList.length == 1) {
        console.log("COMING IN onSelectHandlerPayment");
        this.onSelectHandlerPayment(paymentModesList[0]);
      }

      return this.getPaymentTypesList.filter((x) =>
        allowedPmIds.includes(x.pm_id)
      );
    },
    CashCardCustEmail() {
      return this.$store.getters.CashCardCustEmail;
    },
    showCashCardCustomer() {
      return this.cashCardsList.length > 0 ? true : false;
    },
  },
  beforeMount() {
    if (
      !this.$can("create", "Make A Refund") ||
      !this.$can("update", "Make A Refund")
    ) {
      this.$router.push({
        path: "/access-denied",
      });
    }

    this.getCinemaList();

  },
  mounted() {
    this.getRefunds();
    this.fetchPaymentTypesList();
    if (
      CLIENT_NAME.LEBANON == this.CLIENT_SETUP_NAME ||
      CLIENT_NAME.STUESSIHOF == this.CLIENT_SETUP_NAME ||
      CLIENT_NAME.XANADU == this.CLIENT_SETUP_NAME ||
      CLIENT_NAME.BILDHAUS == this.CLIENT_SETUP_NAME
    ) {
      this.getCustomerList();
    }
    let queryparams = this.$route.query;
    if (queryparams.booking_id) {
      this.booking_id = queryparams.booking_id;
    }
  },
  methods: {
    ...mapActions([
      // FETCH FROM MASTER STORE
      "fetchPaymentTypesList",
    ]),
    getCinemaList: function () {
      MasterService.GetCinemas()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.cinema_id = event['cine_id']
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    removeWalletDetails() {
      this.walletDetails = {
        wallet_balance: 0,
        cust_id: null,
        cust_email: "",
        cust_name: "",
        cust_mobile: "",
        isApplied: "N",
      };
      this.search_wallet_no = "";
    },
    onSearchWallet() {
      if (!this.search_wallet_no) {
        return this.$toasted.show("Please Enter Registered Number");
      } else {
        let payload = {
          cust_mobile: this.search_wallet_no,
        };
        PosService.getWalletBalance(payload)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              if (data.hasOwnProperty("customer_details")) {
                Object.keys(this.walletDetails).map((key) => {
                  this.walletDetails[key] = data.customer_details[key];
                });
                this.walletDetails.isApplied = "Y";
              }
            } else {
              this.$toasted.show(data.message || "Something Went Wrong!");
            }
          })
          .catch((err) => {
            console.log("Error:", err);
            this.$toasted.show("Something Went Wrong!");
          });
      }
    },
    onChangeStockReload(event, type, Itemindex, ci_index = null) {
      if (type == "combo" && ci_index) {
        this.FnbItemArray[Itemindex].combo_data[ci_index].reload_stock = event;
      } else {
        this.FnbItemArray[Itemindex].reload_stock = event;
      }
    },
    onClickBack() {
      this.$router.push({ path: "/" });
    },
    processRefund: function (confirmStock = false) {
      if (
        !confirmStock &&
        this.allow_fnb_refund == "Y" &&
        this.FnbItemArray.length > 0 &&
        this.FnbItemArray.some(
          (x) =>
            x.hasOwnProperty("is_stock_deducted") && x.is_stock_deducted == "Y"
        )
      ) {
        this.$bvModal.show("confirmStockDeduction");
      } else if (this.refund.rr_id) {
        this.$bvModal.hide("confirmStockDeduction");
        let data = {
          ...this.BookingDetails,
          ...this.refund,
          ...this.online_pm_details,
        };
        console.log("data", data)
        this.Selectedseats = _.cloneDeep(this.seats);
        if (data) {
          this.selectedBooking = data;
          this.booking_id = data.sb_booking_code;
          this.order_code = data.order_code;
        }

        if (this.booking_id == "") {
          return this.$toasted.show("Enter Booking ID");
        } else {
          this.disableRefundBtn = true;
          let payload = {
            booking_id: this.booking_id,
            order_code: this.order_code,
          };
          PosService.GetFnbOrderDetails({ ...payload, cinema_id: this.dropDown['selectedCinemaId'] })
            .then((response) => {
              const { data } = response;
              console.log("GetFnbOrderDetails", data);

              if (data && data.status) {
                this.OrderItems = data.Records.filter(
                  (x) => x.refund_datetime == null && x.is_refund == "N"
                ).map((y) => {
                  return { ...y, keyboardActive: false };
                });

                if (this.OrderItems && this.OrderItems.length > 0) {
                  this.OrderItems.forEach((fi) => {
                    fi["reload_stock"] = "N";
                    if (fi.hasOwnProperty("combo_data") && fi.combo_data) {
                      fi["combo_data"] = fi.combo_data
                        ? JSON.parse(fi.combo_data)
                        : [];
                      if (fi.combo_data.length > 0) {
                        fi.combo_data.map((c) => {
                          c["reload_stock"] = "N";
                        });
                      }
                    }
                  });
                }

                this.AlreadyRefunded = data.Records.filter(
                  (x) => x.refund_datetime != null && x.is_refund == "Y"
                );
              }
            })
            .catch((err) => {
              this.disableRefundBtn = false;
              return Promise.resolve();
            })
            .then(() => {
              console.log("COMING HERE IN updatePGRefundStatus REFUND");
              this.updatePGRefundStatus();
            });
        }
      } else {
        this.$toasted.show("Please Select Refund Reason");
      }
    },

    updateBrijRefundStatus: function () {
      this.disableRefundBtn = true;
      let pm = this.refund.payment_mode_id
        ? this.getPaymentTypesList.filter(
          (x) => x.pm_id == this.refund.payment_mode_id
        )[0]
        : {
          pm_payment_mode:
            this.selectedBooking.srt_payment_type == "3" // 'Amazon PayFort'
              ? "Amazon PayFort"
              : this.selectedBooking.srt_payment_type == "4" // 'Master/Visa'
                ? "Master/Visa"
                : this.selectedBooking.srt_payment_type == "5" // 'Al Rajhi Bank'
                  ? "Al Rajhi Bank"
                  : this.selectedBooking.srt_payment_type == "12"
                    ? "Secure Acceptance Checkout"
                    : this.selectedBooking.srt_payment_type == "13"
                      ? "CC AVENUE"
                      : this.selectedBooking.srt_payment_type == "6"
                        ? "Khalti E-Payment"
                        : "",
        };

      this.selectedPayment = pm.pm_payment_mode;
      if (!this.RefundReason || !this.refund.rr_id) {
        let rr =
          this.Refunds.filter((x) => x.rr_id == this.refund.rr_id)[0] ||
          this.Refunds[0];
        this.RefundReason = rr.rr_reason;
        this.refund.rr_id = rr.rr_id;
      }

      this.refund.seat_amount_total = 0;

      this.Selectedseats.map((x) => {
        this.refund.seat_amount_total =
          parseFloat(this.refund.seat_amount_total) +
          parseFloat(x.t_gross_amount);
      });

      this.refund.seat_amount_total += parseFloat(
        this.refund.total_add_ons_charge
      );
      this.refund.seat_amount_total += parseFloat(
        this.refund.internet_handling_fee
      );
      this.refund.enterRefundAmount = this.refund.seat_amount_total.toFixed(this.MIN_FRACTION_DIGITS);

      // fnb stuff
      if (this.order_code) {
        let refundAmount = 0;
        this.OrderItems.forEach((x) => {
          x.refund_reason = this.RefundReason;
          x.refund_payment_mode_id = this.refund.payment_mode_id;
          x.refund_payment_mode_name = this.refund.payment_mode_name;
          x.is_refund = "Y";
          refundAmount = +parseFloat(x.refunded_amount) + refundAmount;
        });
      }

      if (String(this.refund.booking_status_id) === "12") {
        console.log("Refund has been done");
        this.$toasted.show("Refund has been done");
        this.disableRefundBtn = false;
      }
      else if (
        !pm ||
        !this.refund.enterRefundAmount ||
        this.refund.enterRefundAmount.length == 0
      ) {
        console.log("Please enter refund amount");
        this.$toasted.show("Please enter refund amount");
        this.disableRefundBtn = false;
      } else if (!this.selectedPayment || this.selectedPayment.length == 0) {
        console.log("Please select payment mode");
        this.$toasted.show("Please select payment mode");
        this.disableRefundBtn = false;
        return;

      }
      else {
        this.disableRefundBtn = true;
        let ssb_ids = [];
        let sl_ids = [];
        this.Selectedseats.map((y) => {
          this.seats.map((x) => {
            if (x.sl_id == y.sl_id) {
              ssb_ids.push(y.ssb_id);
              sl_ids.push(y.sl_id);
            }
          });
        });
        let payload = {
          ...this.refund,
          ssb_id: ssb_ids,
          sl_id: sl_ids,
          cinema_id: this.dropDown['selectedCinemaId']
        };
        return PosService.updateRefundStatus(payload)
          .then((response) => {
            this.$store.dispatch("onSetAndSendLog", {
              action: ` Selected refund for :${this.booking_id} and refund amount to be given was : ${this.refund.enterRefundAmount} `,
              page_name: "Dashboard Refund",
              api_name: window.location.hash,
            });
            const { data } = response;
            if (data && data.status) {
              this.section.one = true;
              this.section.two = false;
              // this.$toasted.show(data.message);
            } else {
              // this.$toasted.show(data.message);
            }
          })
          .then(() => {
            if (this.order_code) {
              console.log({
                "this.order_code": this.order_code,
              });

              let payload = {
                fnbRefundList: this.OrderItems,
                cinema_id: this.selectedBooking.cine_id,
              };
              // if (this.isCashCardRefund) {
              //   payload["cashCardDetails"] = this.cashCardDetails;
              // }
              return PosService.fnbRefund(payload)
                .then((response) => {
                  const { data } = response;
                  if (data && data.status) {
                    // this.$toasted.show(data.message);
                  } else {
                    // this.$toasted.show(data.message);
                  }
                })
                .catch((err) => {
                  this.disableRefundBtn = false;
                  console.log("fnbRefund Error: ", err);
                });
            }
          })
          .finally(() => {
            this.disableRefundBtn = false;
            this.section.three = true;
            this.section.one = false;
            this.section.two = false;
            this.onPrintHandler();
            this.ResetData();
            this.$toasted.show(data.message);
          });
      }
    },

    updatePGRefundStatus() {
      this.disableRefundBtn = true;
      this.loaderInstance = this.$loading.show();
      let amount = 0;

      amount = parseFloat(this.refund.enterRefundAmount).toFixed(
        this.MIN_FRACTION_DIGITS
      );

      if (this.allow_fnb_refund == "Y") {
        amount += parseFloat(this.FnbRefundAmount || 0);
      }
      let payload = {
        reservation_id: this.selectedBooking.reservation_id,
        cinema_id: this.selectedBooking.cine_id,
        currency: this.refund.curr_code,
        fort_id: this.selectedBooking.payment_transaction_detail.fort_id || "",
        sr_id: this.selectedBooking.sr_id || "",
        pm_payment_mode:
          this.selectedBooking.srt_payment_type == "3" // 'Amazon PayFort'
            ? "Amazon PayFort"
            : this.selectedBooking.srt_payment_type == "4" // 'Master/Visa'
              ? "Master/Visa"
              : this.selectedBooking.srt_payment_type == "5" // 'Al Rajhi Bank'
                ? "Al Rajhi Bank"
                : this.selectedBooking.srt_payment_type == "12"
                  ? "Secure Acceptance Checkout"
                  : this.selectedBooking.srt_payment_type == "13"
                    ? "CC AVENUE" :
                    this.selectedBooking.srt_payment_type == "18" //Bank Muscat
                      ? "Bank Muscat"
                      : this.selectedBooking.srt_payment_type == "6"
                        ? "Khalti E-Payment"
                        : "",
        encryptAmount: encryptString(
          parseFloat(amount || 0).toFixed(this.MIN_FRACTION_DIGITS)
        ),
        amount:
          this.getSafe(
            () => amount
          ) ||
          this.getSafe(
            () => this.selectedBooking.payment_transaction_detail.amount
          ) ||
          this.getSafe(
            () => this.selectedBooking.payment_transaction_detail.amt
          ),
      };

      return PosService.PaymentGatewayRefundApi(payload)
        .then((resData) => {
          console.log({
            resData,
          });
          console.log("resData line 1134", resData);
          if (resData.data.status == true) {
            this.$forceUpdate();
            this.$toasted.show(resData.data.message);
            return this.updateBrijRefundStatus();
          } else {
            this.$toasted.show(
              typeof resData.data.message == "string"
                ? resData.data.message
                : "Something Went Wrong!."
            );
            return Promise.reject();
          }
        })
        .catch((error) => {
          this.disableRefundBtn = false;
          console.log("ERROR line 1146", error);
          console.log({ error });
        })
        .finally(() => {
          this.loaderInstance && this.loaderInstance.hide();
        });
    },
    onCheckAuthentication(response) {
      const { valid, name } = response;
      if (valid) {
        if (name == "dashRefund") {
          this.noAuth = true;
          this.$bvModal.hide("authManager_dashRefund");
          this.show2();
        }
      }
    },
    onSelectCustomer(customer) {
      this.selected_cust_email = customer.cust_email;
      this.cc_customer_field_error = "";
    },
    getCustomerList: function () {
      let payload = {
        tableName: "customers",
        cust_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.customerList = data.Records;
            this.customerList.forEach((x) => {
              x["customer_name"] = x.cust_name
                ? x.cust_name
                : x.last_name
                  ? x.first_name + " " + x.last_name
                  : x.first_name
                    ? x.first_name
                    : "";
            });
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    checkPaymentModeValidation() {
      let count = 0;
      let error_msg = "";
      if (this.isCashCardRefund) {
        if (!this.search_ccn) {
          count++;
          this.cc_input_error = "Please Enter Cash Card Number";
        } else if (this.cashCardsList.length == 0) {
          count++;
          error_msg = "No Cash Card Details Found";
          this.$toasted.show(error_msg);
        } else if (this.cardSaleType == 2 && !this.selectedCustomer) {
          count++;
          error_msg = "Please Select Cash Card Customer";
          this.cc_customer_field_error = "Please Select Cash Card Customer";
          this.$toasted.show(error_msg);
        }
      }
      if (count > 0) {
        return false;
      } else {
        return true;
      }
    },
    checkIsStreetSale(card) {
      if (card && card.hasOwnProperty("customer_id") && card.customer_id) {
        return false;
      } else if (
        card &&
        card.hasOwnProperty("is_guest_user") &&
        card.is_guest_user == "Y"
      ) {
        return false;
      } else if (card && card.is_street_sale == "Y") {
        return true;
      } else {
        return true;
      }
    },
    checkCustomer(card) {
      if (card && card.hasOwnProperty("customer_id") && card.customer_id) {
        return true;
      } else if (
        card &&
        card.hasOwnProperty("is_guest_user") &&
        card.is_guest_user == "Y"
      ) {
        return true;
      } else if (card && card.is_street_sale == "Y") {
        return true;
      } else {
        return false;
      }
    },
    getCardName(card) {
      let name = ``;
      if (card.customer_id) {
        name = `${card.first_name} ${card.last_name ? card.last_name : ""}`;
      } else if (
        card &&
        card.hasOwnProperty("is_guest_user") &&
        card.is_guest_user == "Y"
      ) {
        name = `${card.guest_first_name} ${card.guest_last_name ? card.guest_last_name : ""
          }`;
      } else if (card.is_street_sale == "Y") {
        name = `Street Sale`;
      } else {
        name = "-";
      }
      return name;
    },
    onSearchCashCard() {
      this.cc_input_error = "";
      if (this.search_ccn) {
        if (this.search_ccn.replace(/\s/g, "").length !== 12) {
          this.cc_input_error = "Please Enter 12 digit Card Number";
        } else if (isNaN(this.search_ccn.replace(/\s/g, ""))) {
          this.cc_input_error = "Please Enter Valid Cash Card Number";
        } else {
          this.getCashCardDetails();
        }
      } else {
        this.cashCardsList = [];
      }
    },
    getCashCardDetails: function () {
      let loader = this.$loading.show();
      this.cashCardsList = [];
      let payload = {
        perPage: 10,
        currentPage: 1,
        columnName: "",
        orderBy: "created_at",
        searchValue: this.search_ccn,
        filter_is_active: "Y",
      };

      PosService.GetCashCardList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.data.length > 0) {
            this.cashCardsList = data.Records.data;
          } else {
            this.cashCardsList = [];
            this.$toasted.show(this.$t("No Cash Cards Found"));
          }
        })
        .catch((error) => {
          this.$toasted.show(error);
        })
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    },
    onSelectHandler: function (item) {
      this.RefundReason = item.rr_reason;
      this.refund.rr_id = item.rr_id;
    },
    onSelectHandlerPayment: function (item) {
      this.selectedPayment = item.pm_payment_mode;
      // console.log("selectedPayment",item)
      this.refund.payment_mode_id = item.pm_id;
      this.refund.payment_mode_name = item.pm_payment_mode;
      if (
        item.pm_payment_mode == "Online" ||
        ["20", "21", "22", "18", "41"].includes(String(item.pm_id))
      ) {
        this.onlineMode = this.isMif ? false : true;
      }
      else if (this.amount_is_active == "Y" && ["24"].includes(String(item.pm_id))) {
        this.onlineMode = true;
        console.log("amount_is_active", this.amount_is_active)
      }
      else {
        this.onlineMode = false;
      }
    },
    onSelectSeats(seat) {
      if (Array.isArray(seat)) {
        seat.map((x) => {
          this.refund.seat_amount_total =
            parseFloat(this.refund.seat_amount_total) +
            parseFloat(x.t_gross_amount) +
            parseFloat(this.addonsChargesObj["perTicketAddonCharge"] || 0);
        });
      } else {
        this.refund.seat_amount_total =
          parseFloat(this.refund.seat_amount_total) +
          parseFloat(seat.t_gross_amount) +
          parseFloat(this.addonsChargesObj["perTicketAddonCharge"] || 0);
      }

      this.refund.enterRefundAmount = this.refund.seat_amount_total.toFixed(this.MIN_FRACTION_DIGITS);
    },
    onRemoveSeats(seat) {
      if (Array.isArray(seat)) {
        seat.map((x) => {
          this.refund.seat_amount_total =
            parseFloat(this.refund.seat_amount_total) -
            parseFloat(x.t_gross_amount) -
            parseFloat(this.addonsChargesObj["perTicketAddonCharge"] || 0);
        });
      } else {
        this.refund.seat_amount_total =
          parseFloat(this.refund.seat_amount_total) -
          parseFloat(seat.t_gross_amount) -
          parseFloat(this.addonsChargesObj["perTicketAddonCharge"] || 0);
      }

      this.refund.enterRefundAmount = this.refund.seat_amount_total.toFixed(this.MIN_FRACTION_DIGITS);
    },
    callClose: function () {
      this.onClickHandler("PosRefund");
    },
    show1: function () {
      this.section.one = true;
      this.section.two = false;
    },
    show2: function () {
      console.log("this.noAuth", this.noAuth);
      if (!this.dropDown['selectedCinemaId']) {
        return this.$toasted.show("Please select cinema")
      }
      if (this.booking_id == "") {
        return this.$toasted.show("Enter Booking ID");
      } else if (this.MANAGER_AUTH_FOR_CHANGES == "Y" && !this.noAuth) {
        this.$bvModal.show("authManager_dashRefund");
      } else {
        let payload = {
          booking_id: this.booking_id,
          cinema_id: this.dropDown['selectedCinemaId']
        };
        PosService.getRefundReason(payload)
          .then((result) => {
            const { data } = result;
            if (data && data.status && !data.needCinemaManagerLogin) {
              this.section.one = false;
              this.section.two = true;
              this.RefundReason = data.Records[0].rr_reason;
              this.seats = data.Records;
              this.seatsArr = [
                {
                  label: "All",
                  SeatsArray: data.Records,
                },
              ];
              this.Selectedseats = data.Records.filter((x) => {
                return x.sl_id;
              });
              this.getPaymentTypesList.map((x) => {
                if (x.pm_id == data.Records[0].payment_mode_id) {
                  this.selectedPayment = x.pm_payment_mode;
                }
              });
              this.refund = {
                booking_id: this.booking_id,
                ...this.refund,
                ...data.Records[0],
              };
            } else if (!data.status && data.needCinemaManagerLogin) {
              this.CheckLogin();
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      }
    },
    checkRefundPayMode(confirmStock = false) {
      let ssb_ids = [];
      let sl_ids = [];

      this.Selectedseats.map((y) => {
        this.seats.map((x) => {
          if (x.sl_id == y.sl_id) {
            ssb_ids.push(y.ssb_id);
            sl_ids.push(y.sl_id);
          }
        });
      });

      let refundPayload = {
        ...this.refund,
        ssb_id: ssb_ids,
        sl_id: sl_ids,
      };
      if (
        !confirmStock &&
        // this.secureStore.get('BRGLOPSTDE') &&
        this.allow_fnb_refund == "Y" &&
        this.FnbItemArray.length > 0 &&
        this.FnbItemArray.some(
          (x) =>
            x.hasOwnProperty("is_stock_deducted") && x.is_stock_deducted == "Y"
        )
      ) {
        this.$bvModal.show("confirmStockDeduction");
      } else if(["20"].includes(String(this.refund.payment_mode_id))) {
        let data = {
          ...this.BookingDetails,
          ...this.refund,
          ...this.online_pm_details,
        };
        this.selectedBooking = data;
        this.booking_id = data['sb_booking_code'];
        this.order_code = data['order_code'];
        this.updatePGRefundStatus();
      } else {
        this.$bvModal.hide("confirmStockDeduction");
        this.show3();
      }
    },
    show3: function (confirmStock = false) {
      console.log("this.BookingDetails.pm_id", this.BookingDetails.pm_id)
      if (String(this.refund.booking_status_id) === "12") {
        this.$toasted.show("Refund has been done");
      }
      else if (
        !this.refund.enterRefundAmount ||
        this.refund.enterRefundAmount.length == 0
      ) {
        this.$toasted.show("Please enter refund amount");
      } else if (!this.selectedPayment || this.selectedPayment.length == 0) {
        this.$toasted.show("Please select payment mode");
        return;
      } else if (!this.checkPaymentModeValidation()) {
        return;
      }
      else if (
        !confirmStock &&
        this.allow_fnb_refund == "Y" &&
        this.FnbItemArray.length > 0 &&
        this.FnbItemArray.some(
          (x) =>
            x.hasOwnProperty("is_stock_deducted") && x.is_stock_deducted == "Y"
        )
      ) {
        this.$bvModal.show("confirmStockDeduction");
      } else if (this.overAllRefund == "Y") {
        this.$bvModal.hide("confirmStockDeduction");
        this.refundOverallAmount();
      } else {
        this.$bvModal.hide("confirmStockDeduction");
        let ssb_ids = [];
        let sl_ids = [];
        this.Selectedseats.map((y) => {
          this.seats.map((x) => {
            if (x.sl_id == y.sl_id) {
              ssb_ids.push(y.ssb_id);
              sl_ids.push(y.sl_id);
            }
          });
        });
        if (this.isCashCardRefund && this.cashCardsList.length > 0) {
          this.cashCardDetails = {
            cash_card_number: this.cashCardsList[0].cash_card_number,
            customer_email: this.cashCardsList[0].cust_email
              ? this.cashCardsList[0].cust_email
              : this.selected_cust_email
                ? this.selected_cust_email
                : this.cashCardsList[0].guest_email
                  ? this.cashCardsList[0].guest_email
                  : "",
            type: "1",
            isNewCashCard: this.checkCustomer(this.cashCardsList[0])
              ? "N"
              : "Y",
            isStreetSale:
              this.checkIsStreetSale(this.cashCardsList[0]) &&
                this.cardSaleType == 1
                ? "Y"
                : "N",
            amount: this.refund.enterRefundAmount,
            payment_mode_id: 1,
            cash_log_reason: `Refund Booking ID - ${this.booking_id}`,
            credit_by_refund: "Y",
          };
        }
        let payload = {
          ...this.refund,
          ssb_id: ssb_ids,
          sl_id: sl_ids,
        };

        if (
          this.refund.payment_mode_id == 29 &&
          this.walletDetails["isApplied"] == "Y"
        ) {
          let walletPayload = {
            customer_id: this.walletDetails["cust_id"],
            pm_id: 1,
            amount: +parseFloat(this.refund.enterRefundAmount).toFixed(this.MIN_FRACTION_DIGITS),
            remark: `Refund Booking ID - ${this.booking_id}`,
            credit_by_refund: "Y",
            type: 3,
          };
          payload["walletDetails"] = walletPayload;
        }

        if (this.isCashCardRefund) {
          payload["cashCardDetails"] = this.cashCardDetails;
        }
        PosService.updateRefundStatus(payload)
          .then((response) => {
            this.$store.dispatch("onSetAndSendLog", {
              action: ` Selected refund for :${this.booking_id} and refund amount to be given was : ${this.refund.enterRefundAmount} `,
              page_name: "Dashboard Refund",
              api_name: window.location.hash,
            });
            const { data } = response;
            if (data && data.status) {
              this.disableRefundBtn = false;
              this.section.three = true;
              this.section.one = false;
              this.section.two = false;
              this.onPrintHandler();
              this.ResetData();
              this.$toasted.show(data.message);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      }
    },
    refundOverallAmount() {
      this.disableRefundBtn = true;
      let loader = this.$loading.show();
      this.btnDis = true;
      let ssb_ids = [];
      let sl_ids = [];
      this.$bvModal.hide("confirmStockDeduction");
      console.log("this.Selectedseats :", this.Selectedseats);
      this.Selectedseats.map((y) => {
        this.seats.map((x) => {
          if (x.sl_id == y.sl_id) {
            ssb_ids.push(y.ssb_id);
            sl_ids.push(y.sl_id);
          }
        });
      });
      if (this.isCashCardRefund && this.cashCardsList.length > 0) {
        this.cashCardDetails = {
          cash_card_number: this.cashCardsList[0].cash_card_number,
          customer_email: this.cashCardsList[0].cust_email
            ? this.cashCardsList[0].cust_email
            : this.getCustomerDetails
              ? this.getCustomerDetails.cust_email
              : this.CashCardCustEmail
                ? this.CashCardCustEmail
                : this.cashCardsList[0].guest_email
                  ? this.cashCardsList[0].guest_email
                  : "",
          type: "1",
          isNewCashCard: this.checkCustomer(this.cashCardsList[0]) ? "N" : "Y",
          isStreetSale:
            this.checkIsStreetSale(this.cashCardsList[0]) &&
              this.cardSaleType == 1
              ? "Y"
              : "N",
          amount: this.refund.enterRefundAmount,
          payment_mode_id: 1,
          cash_log_reason: `Refund Booking ID - ${this.booking_id}`,
          credit_by_refund: "Y",
        };
      }
      let payload = {
        ...this.refund,
        ssb_id: ssb_ids,
        sl_id: sl_ids,
        refundApprovedBy: this.refundedApprovedId,
      };

      if (
        this.refund.payment_mode_id == 29 &&
        this.walletDetails["isApplied"] == "Y"
      ) {
        let walletPayload = {
          customer_id: this.walletDetails["cust_id"],
          pm_id: 1,
          amount: +parseFloat(this.refund.enterRefundAmount).toFixed(this.MIN_FRACTION_DIGITS),
          remark: `Refund Booking ID - ${this.booking_id}`,
          credit_by_refund: "Y",
          type: 3,
        };
        payload["walletDetails"] = walletPayload;
      }

      if (this.isCashCardRefund) {
        payload["cashCardDetails"] = this.cashCardDetails;
      }
      if (this.neoleapCardDetails["refund_card_payment_gateway"] == "NEOLEAP") {
        payload["neoleapCardDetails"] = this.neoleapCardDetails;
      }

      PosService.updateRefundStatus(payload)
        .then((response) => {
          const { data: data_1 } = response;
          if (data_1 && data_1.status) {
            this.ApplyFnbRefund()
              .then((response_fnb) => {
                if (response_fnb && response_fnb.status) {
                  this.disableRefundBtn = false;
                  this.section.three = true;
                  this.section.one = false;
                  this.section.two = false;
                  this.onPrintHandler();
                  if (this.isCashCardRefund) {
                    this.MAKE_DATA_EMPTY();
                  }
                  this.$toasted.show(data_1.message);
                } else {
                  this.$toasted.show(response_fnb.message);
                }
              })
              .catch(this._CatchError);
          } else {
            this.$toasted.show(data_1.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            this.btnDis = false;
            this.disableRefundBtn = false;
            loader.hide();
          }, 1000);
        });
    },
    ApplyFnbRefund() {
      this.disableRefundBtn = true;
      let f_refundAmount = 0;
      const { cinema_id } = this.secureStore.get("USINFO");
      return new Promise((resolve, reject) => {
        if (this.allow_fnb_refund == "Y" && this.FnbItemArray.length > 0) {
          this.FnbItemArray.forEach((x) => {
            x.refund_reason = this.RefundReason;
            x.refund_payment_mode_id = this.refund.payment_mode_id;
            x.refund_payment_mode_name = this.refund.payment_mode_name;
            x.is_refund = "Y";
            x.refunded_amount = +parseFloat(x.total_price);
            f_refundAmount = +parseFloat(x.total_price) + f_refundAmount;
          });

          console.log("Final Array", this.FnbItemArray);

          let payload = {
            fnbRefundList: this.FnbItemArray,
            cinema_id: this.BookingDetails.cine_id || cinema_id,
          };

          if (this.isCashCardRefund && this.cashCardsList.length > 0) {
            let FnbCashCardObj = _.cloneDeep(this.cashCardDetails);
            FnbCashCardObj["amount"] = parseFloat(f_refundAmount);
            payload["cashCardDetails"] = FnbCashCardObj;
          }

          if (
            this.refund.payment_mode_id == 29 &&
            this.walletDetails["isApplied"] == "Y"
          ) {
            let walletPayload = {
              customer_id: this.walletDetails["cust_id"],
              pm_id: 1,
              amount: +parseFloat(f_refundAmount).toFixed(this.MIN_FRACTION_DIGITS),
              remark: `Refund Booking ID - ${this.FnbItemArray[0].order_code}`,
              credit_by_refund: "Y",
              type: 3,
            };
            payload["walletDetails"] = walletPayload;
          }

          if (
            this.neoleapCardDetails["refund_card_payment_gateway"] == "NEOLEAP"
          ) {
            payload["neoleapCardDetails"] = this.neoleapCardDetails;
          }

          PosService.fnbRefund(payload)
            .then((response) => {
              const { data } = response;
              resolve(data);
            })
            .catch((err) => {
              console.log("Error: ", err);
              resolve({
                status: false,
                message: "Something Went Wrong in Fnb Refund",
                err,
              });
            });
        } else {
          resolve({
            status: true,
            message: "No Fnb Item For Refund",
          });
        }
      });
    },
    getBookingInfoForTicket() {
      const { username } = this.secureStore.get("USINFO");
      let arabic_company_name = "";

      let arabic_company_name_data = JSON.parse(
        this.BookingDetails.cinema_translation_data
      ).filter((lang) => {
        return lang.langaugeId == 3;
      });

      if (
        arabic_company_name_data &&
        arabic_company_name_data.length > 0 &&
        arabic_company_name_data[0].hasOwnProperty("company_name")
      ) {
        arabic_company_name = arabic_company_name_data[0].company_name;
      }

      let tempObj = {
        template_id: this.TemplateList[0].template_id,
        pos_user_name: username,
        translationData: arabic_company_name,
        cine_name: this.BookingDetails.cinema_name,
        cine_address: this.BookingDetails.cinema_address,
        company_name: this.BookingDetails.company_name,
        vat_number: this.BookingDetails.vat_number,
        sb_id: this.BookingDetails.show_booking_id,
        sb_booking_code: this.BookingDetails.sb_booking_code,
        og_show_date: this.BookingDetails.t_show_date_full,
        og_show_time: this.BookingDetails.t_show_time,
        sb_booking_date: this.BookingDetails.sb_booking_date_time,
        sb_booking_time: this.BookingDetails.sb_booking_date_time,
      };

      return tempObj;
    },
    getCinemaTicketTemplate: function () {
      const { cinema_id } = this.BookingDetails;
      let body = {
        cine_id: cinema_id,
      };
      MasterService.TicketTemplateByCinemaID(body).then((response) => {
        const { data } = response;

        if (data.status) {
          if (data.Records && data.Records.length > 0) {
            this.TemplateList = data.Records;
          }
        }
      });
    },
    onPrintHandler: async function (isReprint = false) {
      if (this.checkPrintAvailable) {
        const { cinema_id } = this.BookingDetails;
        const { username, user_id } = this.secureStore.get("USINFO");
        console.log("this.BookingDetails", this.BookingDetails);
        console.log(
          "this.BookingDetails.final_addon_gross_charges",
          this.BookingDetails.final_addon_gross_charges
        );
        let addOnsArr = [];
        let overallPrice = 0;
        let isRefund = true;
        this.BookingDetails.final_addon_gross_charges.map((x) => {
          if (x.length > 0) {
            x.forEach((y) => {
              if (y.is_additional_price_on_ticket == "N") {
                addOnsArr.push(y);
              }
            });
          }
        });
        console.log("addOnsArr", addOnsArr);
        var userAgent = navigator.userAgent.toLowerCase();
        console.log(this.TemplateList, "templateList");
        let bookingInfo = this.getBookingInfoForTicket();
        if (
          this.TemplateList &&
          this.TemplateList.length > 0 &&
          this.checkPrintAvailable
        ) {
          PosService.GetRefundTicketEjs(
            this.BookingDetails["show_booking_id"],
            cinema_id,
            isReprint
          )
            .then((response) => {
              if (response) {
                const { data } = response;
                this.EjsData = data;
                this.$nextTick(() => {
                  const p = new Printd();
                  if (this.$refs.onPrint && this.EjsData != null) {
                    p.print(this.$refs.onPrint, []);
                  }
                });
              }
            })
            .then(() => {
              addOnsArr.map((z, index) => {
                overallPrice += z.final_price;
                setTimeout(() => {
                  let payload = {
                    addOns: JSON.stringify(z),
                    bookingDetails: JSON.stringify(bookingInfo),
                    isReprint: false,
                    isRefund: isRefund,
                  };
                  PosService.GetAddonTicketEjs(payload).then(
                    async (s_response) => {
                      const { data } = s_response;

                      this.EjsData = data;

                      this.$nextTick(() => {
                        const p = new Printd();
                        if (this.$refs.onPrint && this.EjsData != null) {
                          p.print(this.$refs.onPrint, []);
                        }
                      });
                    }
                  );
                }, 2000);
              });
            })
            .then(() => {
              PosService.GetTicketSecurityEjs(
                this.BookingDetails["show_booking_id"],
                cinema_id,
                isReprint,
                addOnsArr,
                isRefund
              ).then(async (s_response) => {
                const { data } = s_response;

                this.EjsData = data;

                this.$nextTick(() => {
                  const p = new Printd();
                  if (this.$refs.onPrint && this.EjsData != null) {
                    p.print(this.$refs.onPrint, []);
                  }
                });
              });
            })
            .then(() => {
              if (
                (this.order_code && this.onlineMode) ||
                (this.allow_fnb_refund == "Y" &&
                  this.FnbItemArray.length > 0 &&
                  this.order_code)
              ) {
                let payload = {
                  OrderCode: this.order_code,
                  Type: "Print",
                  UserID: user_id,
                  isReprint: this.isReprint,
                  isRefund: true,
                };
                PosFnbService.GetFnbRefundEjs(payload)
                  .then(async (response) => {
                    const { data } = response;
                    this.EjsData = data;
                    this.$nextTick(() => {
                      // loader.hide();
                      const p = new Printd();
                      if (this.$refs.onPrint && this.EjsData != null) {
                        p.print(this.$refs.onPrint, []);
                      }
                    });
                  })
                  .catch(this._CatchError);
              }
            })
            .catch(this._CatchError);
        } else {
          console.log("No template selected for Refund Invoice");
        }
      }
    },
    ResetData: function () {
      this.selectedBooking = "";
      this.order_code = "";
      this.OrderItems = [];
      this.AlreadyRefunded = [];
      this.online_pm_details = {
        srt_payment_type: null,
      };
      this.onlineMode = false;
      this.loaderInstance = null;
      this.booking_id = "";
      this.refund = {
        sb_id: null,
        booking_id: null,
        enterRefundAmount: null,
        //
        booking_status_id: null,
        rr_reason: null,
        rr_id: null,
        payment_mode_id: null,
        //
        curr_code: null,
        sb_total_net_amount: null,
        sb_total_amount: null,
        sb_total_amount_paid: null,
      };
      this.seats = [];
      this.Selectedseats = [];
      this.cashCardsList = [];
      this.selected_cust_email = "";
      this.selectedCustomer = "";
      this.RefundReason = "";
      this.selectedPaymentObj = "";
      setTimeout(() => {
        this.$router.go(-1);
      }, 1500);
    },
    getRefunds: function () {
      let body = {
        tableName: "ms_refund_reasons",
        rr_is_active: "Y",
      };
      MasterService.GetActiveList(body)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.Refunds = data.Records;
          } else
            this.$toasted.show(data.message || "Opps! Something went wrong");
        })
        .catch((error) => {
          this.$toasted.show("Catch Error", error);
        });
    },
    CheckLogin: function () {
      this.submitted = true;
      let loader = this.$loading.show();
      this.$validator.validate().then((valid) => {
        if (true) {
          let payload = {
            booking_id: this.booking_id,
            username: "",
            password: "",
            noCheck: true,
            cinema_id: this.dropDown['selectedCinemaId']
          };
          PosService.CheckCinemaManagerLogin(payload)
            .then((response) => {
              const { data } = response;
              this.username = "";
              this.password = "";
              if (data.status) {
                this.section.one = false;
                this.section.two = true;
                this.seats = data.Records;
                this.Selectedseats = data.Records;
                this.seatsArr = [
                  {
                    label: "All",
                    SeatsArray: data.Records,
                  },
                ];
                this.isPrivateShow =
                  data.Records.length > 0 &&
                    data.Records[0].mycinema_booking_type_id &&
                    data.Records[0].mycinema_booking_type_id == 3
                    ? true
                    : false;
                let OfferDetails = data.offerDetails;
                this.BookingDetails = data.bookingDetails;
                console.log("this.BookingDetails", this.BookingDetails)
                this.BookingDetails["cinema_id"] =
                  data.bookingDetails["cine_id"];
                if (
                  data.bookingDetails.hasOwnProperty("fnb_items") &&
                  data.bookingDetails.fnb_items.length > 0
                ) {
                  this.FnbItemArray = data.bookingDetails.fnb_items.filter(
                    (x) => x.is_refund == "N"
                  );
                  if (this.FnbItemArray && this.FnbItemArray.length > 0) {
                    this.FnbItemArray.forEach((fi) => {
                      fi["reload_stock"] = "N";
                      if (fi.hasOwnProperty("combo_data") && fi.combo_data) {
                        fi["combo_data"] = fi.combo_data
                          ? JSON.parse(fi.combo_data)
                          : [];
                        if (fi.combo_data.length > 0) {
                          fi.combo_data.map((c) => {
                            c["reload_stock"] = "N";
                          });
                        }
                      }
                    });
                  }
                  this.FnbRefundAmount = data.bookingDetails.fnb_items.reduce(
                    (acc, { total_price }) => acc + parseFloat(total_price)
                  );
                  this.order_code = data.bookingDetails.hasOwnProperty(
                    "order_code"
                  )
                    ? data.bookingDetails.order_code
                    : null;
                }
                if (
                  data.bookingDetails.hasOwnProperty("onlinePaymentModeDetails")
                ) {
                  this.online_pm_details =
                    data.bookingDetails.onlinePaymentModeDetails || "";
                }
                this.offer_name = OfferDetails.offer_name;
                this.offer_price = OfferDetails.offer_price.toFixed(this.MIN_FRACTION_DIGITS);
                this.voucher_name = OfferDetails.voucher_name;
                this.refund = {
                  booking_id: this.booking_id,
                  ...this.refund,
                  ...data.Records[0],
                };
                this.refund["curr_code"] =
                  data.bookingDetails["currency_code"] || "";
                this.getCinemaTicketTemplate();
              } else {
                this.$toasted.show(
                  data.message ||
                  "Sorry! Something went wrong. kindly contact your administrator"
                );
              }
            })
            .finally(() => {
              loader.hide();
            });
        }
      });
    },
  },
};
</script>

<style>
.invalid_input {
  border: 1px solid red !important;
  border-radius: 10px;
}

.customer_drop_down {
  background-color: none !important;
}

.disableRefundBtn {
  opacity: 0.5;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/MakeARefund/makeARefund.vue